import { SteemActionType } from '@popup/steem/actions/action-type.enum';
const GlobalPropertiesReducer = (state = {}, { type, payload }) => {
    switch (type) {
        case SteemActionType.LOAD_GLOBAL_PROPS:
            return payload;
        default:
            return state;
    }
};
export default GlobalPropertiesReducer;
